(function() {
  'use strict';

  function ModalWelcomeCtrl ($uibModalInstance, Perfil) {
    var ctrl = this;
    var user = Perfil.getCacheUserData();
    ctrl.userPlan = user.planoContrato.tipo.toLowerCase();
    ctrl.close = function () {
      $uibModalInstance.close();
    };
  }

  angular
    .module('mandaeApp')
    .controller('ModalWelcomeCtrl', ModalWelcomeCtrl);

})();
